// Dependecies
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// Store
import user from '../../store/user';

// Hooks
import useLanguage from '../useLanguage';

function useChangePassword(token, clearErrors, setError, error = '') {
  const [, actionUser] = user();
  const [openModal, setOpenModal] = useState(false);
  const [messageError, setMessageError] = useState(error);
  const [t] = useTranslation('routers', { useSuspense: false });
  const { locale } = useLanguage();
  const history = useHistory();

  useEffect(() => {
    actionUser.validateTokenRecoveryPassword(token).then(
      () => {},
      (e) => {
        if (e.status === 404) {
          history.push(`/${locale}/${t('Login')}`);
        }
      }
    );
  }, []);

  const submit = async (data) => {
    const changePassword = {
      password: data.newpassword,
      password_confirmation: data.newpasswordcomfirm,
    };
    actionUser.changePassword(changePassword, token).then(
      () => {
        setOpenModal(true);
      },
      (e) => {
        setMessageError(e.message);
      }
    );
  };

  const closeModal = () => {
    setOpenModal(false);
    history.push(`/${locale}/${t('Login')}`);
  };

  function validatePassword(value, watch, referent) {
    if (value === '') {
      return 'Password is empty';
    }
    if (value !== watch) {
      setError(referent, 'validate', "Passwords don't match");
      return "Passwords don't match";
    }
    clearErrors(referent);
    return true;
  }

  return {
    closeModal,
    openModal,
    messageError,
    validatePassword,
    submit,
  };
}

export default useChangePassword;
